import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Account } from '../../common/types';

function Team() {
  const { user, getAccessTokenSilently } = useAuth0();
  const [team, setTeam] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://hub.aeoncharge.com',
          scope: 'openid profile email',
        });

        const url = `${process.env.REACT_APP_HUB_BACKEND_URL || 'https://hub.aeoncharge.com/api'}/company-team`;
        const options = {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            auth0_user: user,
            sub: user?.sub,
            email: user?.email,
          }),
        };

        fetch(url, options)
          .then((response) => {
            if (!response.ok) {
              throw Error(response.statusText);
            }
            return response.json();
          })
          .then((response) => {
            if (!response) return;
            setTeam(response);
          });
      } catch (error) {
        // console.error(error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mt-10 space-y-6">
      <div className="grid grid-cols-3 space-x-8">
        <form className="flex items-center col-span-2 bg-white border-none rounded-lg h-fit">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute ml-3">
            <path d="M9.58317 18.125C4.87484 18.125 1.0415 14.2916 1.0415 9.58329C1.0415 4.87496 4.87484 1.04163 9.58317 1.04163C14.2915 1.04163 18.1248 4.87496 18.1248 9.58329C18.1248 14.2916 14.2915 18.125 9.58317 18.125ZM9.58317 2.29163C5.55817 2.29163 2.2915 5.56663 2.2915 9.58329C2.2915 13.6 5.55817 16.875 9.58317 16.875C13.6082 16.875 16.8748 13.6 16.8748 9.58329C16.8748 5.56663 13.6082 2.29163 9.58317 2.29163Z" fill="#B1B1B1" />
            <path d="M18.3332 18.9591C18.1749 18.9591 18.0165 18.9008 17.8915 18.7758L16.2249 17.1091C16.1086 16.9915 16.0435 16.8328 16.0435 16.6675C16.0435 16.5021 16.1086 16.3434 16.2249 16.2258C16.4665 15.9841 16.8665 15.9841 17.1082 16.2258L18.7749 17.8925C19.0165 18.1341 19.0165 18.5341 18.7749 18.7758C18.6499 18.9008 18.4915 18.9591 18.3332 18.9591Z" fill="#B1B1B1" />
          </svg>
          <input type="text" placeholder="Search by users.." className="w-full bg-white border-none rounded-lg pr-3 py-3 pl-10" />
        </form>
        <div className="flex items-center col-span-1 bg-white rounded-lg">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute ml-3">
            <path d="M18 2H6C4.34 2 3 3.33 3 4.97V15.88C3 17.52 4.34 18.85 6 18.85H6.76C7.56 18.85 8.32 19.16 8.88 19.72L10.59 21.41C11.37 22.18 12.64 22.18 13.42 21.41L15.13 19.72C15.69 19.16 16.46 18.85 17.25 18.85H18C19.66 18.85 21 17.52 21 15.88V4.97C21 3.33 19.66 2 18 2ZM12 5.75C13.29 5.75 14.33 6.79 14.33 8.08C14.33 9.37 13.29 10.41 12 10.41C10.71 10.41 9.67 9.36 9.67 8.08C9.67 6.79 10.71 5.75 12 5.75ZM14.68 15.06H9.32C8.51 15.06 8.04 14.16 8.49 13.49C9.17 12.48 10.49 11.8 12 11.8C13.51 11.8 14.83 12.48 15.51 13.49C15.96 14.16 15.48 15.06 14.68 15.06Z" fill="#B1B1B1" />
          </svg>
          <select name="role" id="" defaultValue="none" className="w-full border-none rounded-lg p-3 pl-10">
            <option value="none" disabled>Role</option>
            <option value="admin">Admin</option>
            <option value="editor">Editor</option>
            <option value="moderator">Moderator</option>
          </select>
        </div>
      </div>

      <div className="w-full bg-white rounded-lg">
        <div id="table-head" className="grid grid-cols-2 py-3 border-2 rounded-t-md bg-gray-100">
          <div className="flex justify-center items-center">
            <svg aria-hidden="true" className="mr-2 w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 12C22 6.48974 17.5105 2.00024 12.0002 2.00024C6.48999 2.00024 2.00049 6.48974 2.00049 12C2.00049 14.9002 3.24999 17.5102 5.22999 19.3402C5.22999 19.35 5.22999 19.35 5.22024 19.3597C5.31999 19.4602 5.43999 19.5397 5.54049 19.6297C5.60049 19.68 5.64999 19.7302 5.70999 19.77C5.88999 19.92 6.09024 20.0602 6.27999 20.1997C6.35049 20.25 6.41049 20.2897 6.48024 20.34C6.66999 20.4697 6.87024 20.5897 7.08024 20.7C7.14999 20.7397 7.23024 20.79 7.29999 20.8297C7.50024 20.94 7.71024 21.0397 7.92999 21.1297C8.01024 21.1702 8.09049 21.21 8.16999 21.24C8.39049 21.33 8.61024 21.4102 8.82999 21.48C8.91024 21.51 8.99049 21.54 9.06999 21.5602C9.30999 21.63 9.54999 21.69 9.78999 21.75C9.86049 21.7702 9.93024 21.7897 10.0105 21.8002C10.2902 21.8602 10.57 21.9 10.8602 21.93C10.9 21.93 10.9405 21.9397 10.9802 21.9502C11.32 21.9802 11.6605 21.9997 12.0002 21.9997C12.34 21.9997 12.6805 21.9802 13.0105 21.9502C13.0502 21.9502 13.09 21.9397 13.1305 21.93C13.42 21.9 13.7005 21.8602 13.9802 21.8002C14.05 21.7897 14.1205 21.7597 14.2 21.75C14.44 21.69 14.6905 21.6397 14.92 21.5602C15.0002 21.5302 15.0805 21.5002 15.16 21.48C15.3805 21.3997 15.61 21.33 15.82 21.24C15.9002 21.21 15.9805 21.1702 16.06 21.1297C16.27 21.0397 16.48 20.94 16.69 20.8297C16.7702 20.79 16.84 20.7397 16.9105 20.7C17.11 20.58 17.3102 20.4697 17.5105 20.34C17.5802 20.3002 17.6402 20.25 17.71 20.1997C17.9102 20.0602 18.1 19.92 18.28 19.77C18.34 19.7197 18.3902 19.6702 18.4502 19.6297C18.5605 19.5397 18.67 19.4497 18.7705 19.3597C18.7705 19.35 18.7705 19.35 18.76 19.3402C20.7505 17.5102 22 14.9002 22 12ZM16.9405 16.9702C14.23 15.15 9.78999 15.15 7.05999 16.9702C6.64409 17.2448 6.2732 17.582 5.96049 17.97C4.38532 16.3822 3.50116 14.2365 3.50049 12C3.50049 7.31024 7.31049 3.50024 12.0002 3.50024C16.69 3.50024 20.5 7.31024 20.5 12C20.5 14.3197 19.5602 16.4302 18.04 17.97C17.7297 17.5797 17.3585 17.2421 16.9405 16.9702ZM12.0002 6.92999C9.93024 6.92999 8.25024 8.60999 8.25024 10.68C8.25024 12.7095 9.84024 14.3595 11.95 14.4195H12.13C13.1007 14.3878 14.0211 13.9799 14.6966 13.2821C15.3722 12.5843 15.75 11.6512 15.7502 10.68C15.7502 8.60999 14.0702 6.92999 12.0002 6.92999Z" fill="#113A54" />
            </svg>
            User Name
          </div>
          <div className="flex justify-center items-center">
            <svg aria-hidden="true" className="mr-2 w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 3H6C3.79 3 2 4.78 2 6.97V17.03C2 19.22 3.79 21 6 21H18C20.21 21 22 19.22 22 17.03V6.97C22 4.78 20.21 3 18 3ZM8.5 7.17C9.77 7.17 10.81 8.21 10.81 9.48C10.81 10.75 9.77 11.79 8.5 11.79C7.23 11.79 6.19 10.75 6.19 9.48C6.19 8.21 7.23 7.17 8.5 7.17ZM12.37 16.66C12.28 16.76 12.14 16.82 12 16.82H5C4.86 16.82 4.72 16.76 4.63 16.66C4.58422 16.6084 4.54915 16.5483 4.52683 16.4831C4.50451 16.4178 4.49539 16.3488 4.5 16.28C4.58359 15.4644 4.94705 14.7029 5.5286 14.125C6.11015 13.5471 6.8739 13.1885 7.69 13.11C8.2255 13.06 8.7645 13.06 9.3 13.11C10.98 13.27 12.33 14.6 12.49 16.28C12.51 16.42 12.46 16.56 12.37 16.66ZM19 16.75H17C16.59 16.75 16.25 16.41 16.25 16C16.25 15.59 16.59 15.25 17 15.25H19C19.41 15.25 19.75 15.59 19.75 16C19.75 16.41 19.41 16.75 19 16.75ZM19 12.75H15C14.59 12.75 14.25 12.41 14.25 12C14.25 11.59 14.59 11.25 15 11.25H19C19.41 11.25 19.75 11.59 19.75 12C19.75 12.41 19.41 12.75 19 12.75ZM19 8.75H14C13.59 8.75 13.25 8.41 13.25 8C13.25 7.59 13.59 7.25 14 7.25H19C19.41 7.25 19.75 7.59 19.75 8C19.75 8.41 19.41 8.75 19 8.75Z" fill="#113A54" />
            </svg>
            User Role
          </div>
        </div>
        <div id="table-body" className="grid grid-cols-2">
          <div id="user-names" className="col-span-1 divide-y">
            { team.map((member: Account) => (
              <div key={member.auth0_sub} className="py-5 flex items-center justify-center">
                <img className="rounded-full h-10 w-10 mr-3.5" src={member.profile_image_src ?? '/user.svg'} alt="user avatar" />
                {`${member.first_name} ${member.last_name}`}
              </div>
            ))}
          </div>
          <div id="user-roles" className="col-span-1 divide-y">
            { team.map((member: Account) => (
              <div key={member.auth0_sub} className="py-5 flex items-center justify-center">
                <span className="flex items-center h-10">
                  {member.role ?? 'Admin'}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Team;
